const replacements = {
    state: {
        new: []
    },
    mutations: {
        SET_NEW_REPLACEMENTS_NAME(state, payload) {
            state.new[payload.index].name = payload.value
        },
        SET_NEW_REPLACEMENTS_COST(state, payload) {
            state.new[payload.index].cost = payload.value
        },
        SET_NEW_REPLACEMENTS(state, payload) {
            state.new = payload
        }
    },
    getters: {
        getNewReplacements: state => state.new,
        getNewReplacementsValue(state) {
            if (!state.new[0]) {
                return 0
            }

            return state.new.map((el) => {
                if (el.cost) {
                    return el.cost
                }

                return 0
            }).reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
        }
    }
}

export default replacements